
const Frame = ({width, height, src, title, frameborder, allow, referrerpolicy, allowfullscreen, img, className}) => {
  return (
    <div className={`frame__ ${className}`}>
      <iFrame width={width} height={height} src={src} title={title} frameborder={frameborder} allow={allow} referrerpolicy={referrerpolicy} allowfullscreen={allowfullscreen} img={img}/>
    </div>
  )
}

export default Frame